import { Spacing, Stack, styled, themeMediaQuery } from 'ui';

export const StyledButtonContent = styled('div')`
  display: flex;
  padding: ${({ theme }) => theme.spacing(Spacing.Small)};
  gap: ${({ theme }) => theme.spacing(Spacing.Small)};
  justify-content: flex-end;
  width: 100%;
`;

export const FormStack = styled(Stack)`
  width: 320px;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
  padding: ${({ theme }) => theme.spacing(Spacing.Large, Spacing.Medium)};
  ${({ theme }) => themeMediaQuery(theme, 'sm')`
    width: 480px;
  `}
`;

export const SectionHeader = styled(Stack)`
  gap: ${({ theme }) => theme.spacing(Spacing.Tiny)};
`;
